export const breakpoints = {
  xxs: 370,
  xs: 390,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
} as const

export type BreakpointKey = keyof typeof breakpoints
export type BreakpointValue = (typeof breakpoints)[keyof typeof breakpoints]

export const breakpointQuery = (val: BreakpointValue, options?: { max: boolean }) =>
  `(${options?.max ? 'max' : 'min'}-width: ${options?.max ? val - 1 : val}px)`
